import React from 'react';
import { injectIntl } from 'react-intl';
import {connect} from 'react-redux';

import { changeTitle } from 'modules/ui';

import 'style/routes/not-authorized.scss';


class NoAuthorized extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            NotAuthorizedTemplate: require(`./no-authorized-templates/${props.service}.js`)
        };
    }


    componentDidMount() {
        const { dispatch, service, intl: { formatMessage }, isModal } = this.props;

        !isModal && dispatch(changeTitle(formatMessage({ id: service !== 'reports' ? 'title.serviceNotFound' : 'notAuthorized.accessDenied' }, {service})));
    }

    componentDidUpdate(prevProps) {
        const { dispatch, service, intl: { formatMessage, locale }, isModal } = this.props;
        const previousLocale = prevProps.intl.locale;

        if (previousLocale && locale && previousLocale !== locale && !isModal) {
            dispatch(changeTitle(formatMessage({ id: service !== 'reports' ? 'title.serviceNotFound' : 'notAuthorized.accessDenied' }, {service})));
        }
    }

    render() {
        const {intl: { formatMessage }} = this.props;
        const {NotAuthorizedTemplate} = this.state;

        return (
            <NotAuthorizedTemplate formatMessage={formatMessage} />
        );
    }
}

const mapStateToProps = state => null;

export default injectIntl(connect(mapStateToProps)(NoAuthorized));



// WEBPACK FOOTER //
// ./src/routes/NoAuthorized.jsx